const state = () => ({
    card: [],
    bCardVisible: false
});

const mutations = {
    setCard: (state, data) =>
    {
        state.card = data
    },
    setCardVisbility: (state, data) =>
    {
        state.bCardVisible = data
    }
}

const getters = {
    getCard: state => state.card
}

const actions = {
    setCardAction({ commit }, data)
    {
        commit('setCard', data);
    },
    setCardVisbilityAction({ commit }, data)
    {
        commit('setCardVisbility', data);
    }
}

export default {
    state, mutations, actions, getters
}